import Alpine from 'alpinejs'

Alpine.data('header', (userAuthenticated: boolean) => ({

    activeLayer: null,
    showWishlistRequiresLoginNote: false,
    userAuthenticated: userAuthenticated,
    
    openWishList() {
        if(!userAuthenticated) {
            this.openAccount()
            this.showWishlistRequiresLoginNote = true
        }
    },
    
    openAccount() {
        this.showWishlistRequiresLoginNote = false
        this.activeLayer = 'account'
    },
    
    openSearch() {
        this.activeLayer = 'search'
    },

    openMenu() {
        this.activeLayer = 'menu'
        this.$dispatch('mobile-menu-open')
    },
    
    close() {
        this.activeLayer = null
        this.showWishlistRequiresLoginNote = false
    },
    
    init() {
        this.$watch('activeLayer', (value) => {
            if(value) {
                this.$dispatch('modal-open')
            } else {
                this.$dispatch('modal-closed')
            }
        })
    }
    
}));